<template>
    <div id="line" class="line" style="width:100%;height:100%;"></div>
</template>
<script>
import * as echarts from 'echarts';
export default{
    props: {
        data: {
            type: Object,
            default: (()=>{
                return {}
            })
        },
    },
    data(){
        return{
            chart:null
        }
    },
    watch: {
        data: {
            handler(v) {
                if (v.xData && v.xData.length) {
                    this.$nextTick(() => {
                        this.initChart()
                    })
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        // this.initChart()
    },
    beforeDestroy() {
        if (!this.chart) {
        return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            var _this = this
            this.chart = this.$echarts.init(document.getElementById('line'))
            var option = {
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '0%',
                    top:'18%',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis'
                },  
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: _this.data.xData
                },
                yAxis: {
                     name: '单位(元)',
                    type: 'value'
                },
                series: _this.data.yData
            };
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                if (this.chart) {
                    this.chart.resize()
                }
            })
        }
    }
}
</script>